<template>
      <div class="day">
        <div
          :class="['header', 'header-cell', 'header-active', 'text-subtitle1', $q.platform.is.mobile ? 'mobile' : '']"
          >
            &nbsp;
        </div>
        <div
          :class="['grid-cell', 'lesson-field', 'text-weight-light', $q.platform.is.mobile ? 'mobile' : '']"
          v-for="n in 15"
          :key="`${n}`"
          >
          {{ scheduleText(n) }}
        </div>
      </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'DayLessons',
  props: {
  },

  computed: {
    ...mapGetters('global', ['schedule'])
  },
  data () {
    return {
    }
  },

  methods: {
    scheduleText (lesson) {
      if (lesson === -1) {
        return ''
      }
      if (this.$q.platform.is.mobile) {
        return this.schedule[lesson - 1].substr(0, 5)
      } else {
        return this.schedule[lesson - 1]
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~quasar-variables'

.text-no-wrap-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.day {
  // max-width: 200px;
  // min-width: 200px;
}

.grid-cell {
  padding: 10px 20px 11px 20px;
  text-align: center;
  // background: rgba(86, 61, 124, 0.15);
  border-top: 1px solid $grey-4;
  &.mobile {
    // padding: 10px 10px 11px 10px;
    padding: 0px 10px 21px 10px;
  }
}

.header-cell {
  padding: 10px 20px 13px 20px;
  border-bottom: 3px;
  &.mobile {
    // padding: 10px 10px 11px 10px;
  }
}

.lesson-field {
  margin: 1px;
}

</style>
